import { useEffect } from "react";
import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import { profile } from "@/data/portfolio";

function App() {
  useEffect(() => {
    document.title = `${profile.name} — ${profile.roles[0]}`;
  }, []);

  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <HashRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </HashRouter>
    </ThemeProvider>
  );
}

export default App;
